import { isTransientRequestError } from '@/api/isTransientRequestError';
import { VOICE_RETRY_DELAY_MILLISECONDS } from '@/constants/assistantVoice';

function waitBeforeRetry(): Promise<void> {
  return new Promise(function resolveLater(resolve) {
    window.setTimeout(resolve, VOICE_RETRY_DELAY_MILLISECONDS);
  });
}

export async function retryOnceAfterTransientError<Result>(
  operation: () => Promise<Result>
): Promise<Result> {
  try {
    return await operation();
  } catch (caughtError) {
    if (!isTransientRequestError(caughtError)) {
      throw caughtError;
    }
    await waitBeforeRetry();
    return operation();
  }
}
